import { useQuery } from "react-query";
import * as categoryService from 'services/categoryService';
import { ListCategoryProductsDto } from "types/dto/ListCategoryProductsDto";


export const useGetRootCategories = (options = {}) => {
  return useQuery({
    queryKey: ['rootCategories'],
    queryFn: categoryService.getRootCategories,
    ...options
  });
}

export const useGetCategories = (categoryId: string, options = {}) => {
  return useQuery({
    queryKey: ['categories', categoryId],
    queryFn: () => categoryService.getCategories(categoryId),
    ...options
  });
}

export const useGetCategoryProducts = (dto: ListCategoryProductsDto, options = {}) => {
  return useQuery({
    queryKey: ['categoryProducts', dto],
    queryFn: () => categoryService.getCategoryProducts(dto),
    ...options
  });
}